import { Controller } from "@hotwired/stimulus"
import {formatGeneral} from "cleave-zen";

// Connects to data-controller="phone"
export default class extends Controller {
  static targets = [ "input" ]

  connect() {
    this.inputTarget.addEventListener('input', (e) => {
      this.inputTarget.value = formatGeneral(e.target.value, {
        blocks: [3, 3, 4],
        delimiter: '-',
        numericOnly: true
      })
    })
  }
}
